module.exports = __webpack_public_path__ + "img/default-image.fee05d3b.png";